module.exports = __webpack_public_path__ + "img/equipments.80d4d705.svg";